import { create } from "zustand";

export const useBridgeStore = create((set) => ({
  sidebarRefresh: null,
  refreshType: "all", // 'chat', 'channel', 'favorite', or 'all'
  triggerSidebarRefresh: (timestamp, type = "all") =>
    set({
      sidebarRefresh: timestamp,
      refreshType: type,
    }),
  channelHeaderRefresh: null,
  searchParticularRecord: { id: 0, name: "" },
  searchMsgText: { value: "", timestamp: 0 },
  jumpConfig: {},
  globalSectionConfig: {
    openedSection: "",
    isExpanded: false,
    payload: "",
  },

  triggerChannelHeaderRefresh: (timestamp) => {
    set({ channelHeaderRefresh: timestamp });
  },

  setSearchParticularRecord: (data) => {
    set({ searchParticularRecord: data });
  },
  setSearchMsgText: (data) => {
    set({ searchMsgText: data });
  },
  setJumpConfig: (data) => {
    set({ jumpConfig: data });
  },

  headerRefresh: null,
  headerRefreshType: "", // 'rename', 'members', 'pins', 'files', or 'all'
  triggerHeaderRefresh: (timestamp, type = "all") =>
    set({
      headerRefresh: timestamp,
      headerRefreshType: type,
    }),
  setGlobalSectionConfig: (data) => {
    set((state) => ({
      globalSectionConfig: {
        ...state.globalSectionConfig,
        ...data,
      },
    }));
  },
  draftRefresh: null,
  triggerDraftRefresh: (timestamp) =>
    set({
      draftRefresh: timestamp,
    }),
  refreshMessageList: null,
  triggerMessageRefresh: (data) =>
    set({
      refreshMessageList: data,
    }),
   hangUp: null,
  triggerHangUp: (timestamp) =>
    set({
      hangUp: timestamp,
    }),
}));
